export class Auth0Error {
    title: string;
    content: string;
    errorId: Auth0ErrorSource;
    subContent: string;
    showAuth0ErrorActions: boolean;
}

export enum Auth0ErrorSource{
    Unauthorized,
    UnifiedIdentity
}
